import { fromJS, List, Map } from 'immutable';

export function request(state) {
    return state.set('state', 'IN_PROGRESS');
}

export function finish(state, { roles }) {
    let itemsMap = Map();

    fromJS(roles).reduce((items, item) => items.concat(item), List()).forEach(role => {
        itemsMap = itemsMap.set(role.get('id'), role);
    });

    let collections = fromJS(roles).map(g => g.map(r => r.get('id')));

    return state
        .set('items', itemsMap)
        .set('collections', collections)
        .set('state', 'FINISHED');
}

export function error(state, { errors }) {
    return state.set('state', 'ERROR').set('errors', errors);
}
